import * as actionTypes from '../actionTypes';

const initialState = {
    importFileSuccess: false,
    importFileFail: false,
    importFailMessage: null,
    importSuccessMessage : null,
    importResultFile: null,
    importResultFileName: null
};
const ImportReducer = (state, { type, payload }) => {

    if (state === undefined) {
        state = initialState
    }
    let object;

    switch (type) {

        case actionTypes.ImportFilesRequested:
            object = { ...state, importFileFail: false, importFailMessage: null, importSuccessMessage: null,
                importFileSuccess: false, importResultFile: null, importResultFileName: null }
            break

        case actionTypes.ImportFilesSuccess:
            object = { ...state, importFileFail: false, importFailMessage: null, importFileSuccess: true,
                importSuccessMessage: typeof payload === 'object' ? payload.detail : payload,
                importResultFile: typeof payload === 'object' ? payload.file_content : null,
                importResultFileName: typeof payload === 'object' ? payload.file_name : null }
            break

        case actionTypes.ImportFilesFailure:
            object = { ...state, importFileFail: true, importFailMessage: payload, importFileSuccess: false,
                importSuccessMessage: null, importResultFile: null, importResultFileName: null }
            break

        case actionTypes.LogOut:
            object = { state: undefined };
            break


        default:
            object = state;
    }
    return object
};
export default ImportReducer;
